import { ReactionType, ReactionContextType, StickerReactionPayload } from '../../../typings';
import { getReactions, GetReactionsFilters } from './get-reactions';

export interface ClessonStudentsStickersRequest {
    clessonId: number;
    studentIds?: number[];
}

export function getClessonStudentsStickers(
    request: ClessonStudentsStickersRequest
) {
    const filters: GetReactionsFilters = {
        reaction_type: ReactionType.STICKER,
        context_id: [request.clessonId],
        context_type: ReactionContextType.CLESSON,
    };
    if (request.studentIds) {
        filters.receiver_id = request.studentIds;
    }

    return getReactions<StickerReactionPayload>(filters);
}
